// First-party, anonymous visitor tracking (no PII, no third-party cookies)
const API = process.env.REACT_APP_BACKEND_URL;

function uid() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return Date.now().toString(36) + Math.random().toString(36).slice(2);
}

export function getVisitorId() {
  let id = localStorage.getItem("pb_visitor_id");
  if (!id) {
    id = uid();
    localStorage.setItem("pb_visitor_id", id);
  }
  return id;
}

export function getSessionId() {
  let id = sessionStorage.getItem("pb_session_id");
  if (!id) {
    id = uid();
    sessionStorage.setItem("pb_session_id", id);
  }
  return id;
}

export function trackPageview(path) {
  try {
    const body = JSON.stringify({
      path,
      referrer: document.referrer || "",
      session_id: getSessionId(),
      visitor_id: getVisitorId(),
    });
    fetch(`${API}/api/analytics/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    /* tracking must never break the page */
  }
}
